module.exports = __webpack_public_path__ + "img/logo_dip.7ad89bc0.svg";